import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Alert,
  Box,
  Button,
  // Divider,
  FormHelperText,
  TextField,
  // Typography
} from '@material-ui/core';
import useAuth from '../../../hooks/useAuth';
import useMounted from '../../../hooks/useMounted';
import firebase from '../../../lib/firebase';

const LoginFirebase = (props) => {
  const mounted = useMounted();
  const { signInWithEmailAndPassword } = useAuth();
  const auth = useAuth();

  return (
    <div {...props}>
      <Formik
        initialValues={{
          email: '',
          password: '',
          submit: null
        }}
        validationSchema={Yup
          .object()
          .shape({
            email: Yup
              .string()
              .email('Debe ser un formato de email válido')
              .max(255)
              .required('Email es obligatorio'),
            password: Yup
              .string()
              .max(255)
              .required('Password es obligatorio')
          })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            firebase
              .firestore()
              .collection('staff')
              .where('email', '==', values.email)
              .get()
              .then(async (snapshot) => {
                if (!snapshot.empty) {
                  snapshot.forEach((doc) => {
                    console.log(auth.user);
                    auth.user.name = doc.data().name;
                    localStorage.setItem('name', doc.data().name);
                    localStorage.setItem('avatar', doc.data().avatar);
                    localStorage.setItem('rank_id', doc.data().rank.id);
                    localStorage.setItem('rank_value', doc.data().rank.value);
                  });
                  await signInWithEmailAndPassword(values.email, values.password);
                  if (mounted.current) {
                    setStatus({ success: true });
                    setSubmitting(false);
                  }
                } else {
                  setStatus({ success: false });
                  setErrors({ submit: 'Usuario Inválido' });
                  setSubmitting(false);
                }
              })
              .catch((err) => {
                console.error(err);
                if (mounted.current) {
                  setStatus({ success: false });
                  if (err.code === 'auth/wrong-password') {
                    setErrors({ submit: 'La contraseña no es correcta o el usuario no existe' });
                    setSubmitting(false);
                  } else {
                    setErrors({ submit: err.message });
                    setSubmitting(false);
                  }
                }
              });
          } catch (err) {
            console.error(err);
            if (mounted.current) {
              setStatus({ success: false });
              if (err.code === 'auth/wrong-password') {
                setErrors({ submit: 'La contraseña no es correcta o el usuario no existe' });
                setSubmitting(false);
              } else {
                setErrors({ submit: err.message });
                setSubmitting(false);
              }
            }
          }
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
          <form
            noValidate
            onSubmit={handleSubmit}
            {...props}
          >
            <TextField
              error={Boolean(touched.email && errors.email)}
              fullWidth
              helperText={touched.email && errors.email}
              label="Email"
              margin="normal"
              name="email"
              onBlur={handleBlur}
              onChange={handleChange}
              type="email"
              value={values.email}
              variant="outlined"
            />
            <TextField
              error={Boolean(touched.password && errors.password)}
              fullWidth
              helperText={touched.password && errors.password}
              label="Contraseña"
              margin="normal"
              name="password"
              onBlur={handleBlur}
              onChange={handleChange}
              type="password"
              value={values.password}
              variant="outlined"
            />
            {errors.submit && (
              <Box sx={{ mt: 3 }}>
                <FormHelperText error>
                  {errors.submit}
                </FormHelperText>
              </Box>
            )}
            <Box sx={{ mt: 2 }}>
              <Button
                color="primary"
                disabled={isSubmitting}
                fullWidth
                size="large"
                type="submit"
                variant="contained"
              >
                Iniciar Sesión
              </Button>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Alert severity="info">
                <div>
                  Sistema
                  {' '}
                  <b>Kocars</b>
                  {' '}
                  en
                  {' '}
                  <b>desarrollo activo</b>
                </div>
              </Alert>
            </Box>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default LoginFirebase;
